import React, { useEffect, createElement } from 'react';
export const MetaPixel = () => {
  useEffect(() => {
    const pixelId = '2782582688765590';
    // Initialize the fbq stub safely without relying on an existing <script> tag.
    const w = window as any;
    if (!w.fbq) {
      const n: any = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      w.fbq = n;
      if (!w._fbq) w._fbq = n;
    }
    // Inject the Facebook events script into <head> (guarded against duplicates).
    const SRC = 'https://connect.facebook.net/en_US/fbevents.js';
    if (!document.querySelector(`script[src="${SRC}"]`)) {
      const t = document.createElement('script');
      t.async = true;
      t.src = SRC;
      const parent = document.head || document.body || document.documentElement;
      parent.appendChild(t);
    }
    w.fbq('init', pixelId);
    w.fbq('track', 'PageView');
  }, []);
  return null;
};